/* eslint-disable no-useless-escape */
import Cookies from 'js-cookie';
import { Common } from '@src/common';

export const checkNumRemainer = (num, unit) => {
  return num % unit;
};

export const secToMil = (value) => {
  return value * 1000;
};

export const byteToMb = (value) => {
  return Math.floor((value / (1024 * 1024)) * 100) / 100;
};

export const numCuttingByUnit = (value, unit) => {
  return Math.round(value / unit) * unit;
};

export const milToSec = (value) => {
  return Math.floor(value / 1000);
};

export const convertArrayBufferToBase64 = (data) => {
  let binary = '';
  const bytes = new Uint8Array(data);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
};

export const getDataURI = ({ type, data }) => {
  const dataURI = `data:${type};base64,${data}`;
  const isDataURI = Common.EXP_TYPE_DATA_URI.test(dataURI);
  return isDataURI ? dataURI : '';
};

export const isNotNull = (value) => {
  if (value === '') return false;
  if (value === ' ') return false;
  if (value === undefined) return false;
  if (value === null) return false;
  return true;
};

export const isNotNullwithoutSpace = (value) => {
  if (value === '') return false;
  if (value === undefined) return false;
  if (value === null) return false;
  return true;
};

export const isNumberZero = (value) => {
  if (value === '') value = 0;
  if (value === ' ') value = 0;
  if (value === undefined) value = 0;
  if (value === null) value = 0;
  return value;
};

export const isEnter = (text) => {
  if (text === '\n') {
    return true;
  }
  return false;
};

export const assert = (condition, value) => {
  if (condition !== value) return false;
  return true;
};

export const YNtoBoolean = (value) => {
  return value === 'Y';
};

export const dataUriRegex = () => {
  // https://github.com/ragingwind/data-uri-regex
  // data-uri scheme
  // data:[<media type>][;charset=<character set>][;base64],<data>
  return new RegExp(/^(data:)([\w\/\+]+);(charset=[\w-]+|base64).*,(.*)/gi);
};

export const singleToDoubleByte = (char = '') => {
  // 반각 문자를 전각 문자로 변환하는 함수
  const finalText: string[] = []; // 변환된 문자들의 배열
  let charCode; // 각 문자의 코드값
  let result = ''; // 변환된 문자열
  const excludeCharset = [32, 43, 44, 45, 46, 47, 58, 59, 92]; // (" "+,-./:;\)
  let isSingleByteText; // 변환시킬 반각 문자인지 검사하는 조건문
  let isSingleByteSpace; // 띄어쓰기인지 검사하는 조건문

  for (let i = 0; i < char.length; i += 1) {
    charCode = char[i].charCodeAt(0);

    isSingleByteText =
      !excludeCharset.includes(charCode) && charCode >= 21 && charCode <= 126;
    isSingleByteSpace = charCode === 0 || charCode === 32;

    if (isSingleByteText) {
      // 전각 문자와 반각문자의 charCode 차이값은 65248
      finalText[i] = String.fromCharCode(charCode + 65248);
    } else if (isSingleByteSpace) {
      // 반각 띄어쓰기를 전각으로 변환
      finalText[i] = '　';
    } else {
      finalText[i] = char[i];
    }
  }
  result = finalText.join('');
  return result;
};

// 모바일 체크
export const isMobile = () => {
  const mobilePattern =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  if (mobilePattern.test(navigator.userAgent)) {
    return true;
  }
  return false;
};

export const exceptHandler = (err = {}) => {
  // eslint-disable-next-line no-console
  console.info(err);
};

export const getFileExtension = (path: string): string => {
  const extension = path.match(Common.EXP_TYPE_FILE_EXT);
  return extension ? extension[1] : '';
};

export const getLanguage = () => {
  return Cookies.get(Common.STORAGE_LANG);
};

export default {
  checkNumRemainer,
  secToMil,
  byteToMb,
  numCuttingByUnit,
  milToSec,
  convertArrayBufferToBase64,
  getDataURI,
  isNotNull,
  isNotNullwithoutSpace,
  isNumberZero,
  isEnter,
  assert,
  YNtoBoolean,
  dataUriRegex,
  singleToDoubleByte,
  isMobile,
  exceptHandler,
  getFileExtension,
  getLanguage,
};
